import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletUnsettled = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "vuesax/linear/wallet-2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M10.8333 7.5H5.83333",
				stroke: "#3C3C3C",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M18.3334 9.14164V10.8584C18.3334 11.3167 17.9667 11.6917 17.5 11.7083H15.8667C14.9667 11.7083 14.1417 11.05 14.0667 10.15C14.0167 9.62499 14.2167 9.13332 14.5667 8.79166C14.875 8.47499 15.3 8.29168 15.7667 8.29168H17.5C17.9667 8.30834 18.3334 8.68331 18.3334 9.14164Z",
				stroke: "#3C3C3C",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M14.5667 8.79166C14.2167 9.13332 14.0167 9.62499 14.0667 10.15C14.1417 11.05 14.9666 11.7083 15.8666 11.7083H17.5V12.9167C17.5 15.4167 15.8333 17.0833 13.3333 17.0833H5.83333C3.33333 17.0833 1.66667 15.4167 1.66667 12.9167V7.08333C1.66667 4.81667 3.03334 3.23333 5.15834 2.96666C5.375 2.93333 5.6 2.91667 5.83333 2.91667H13.3333C13.55 2.91667 13.7583 2.92499 13.9583 2.95832C16.1083 3.20832 17.5 4.8 17.5 7.08333V8.29168H15.7667C15.3 8.29168 14.875 8.47499 14.5667 8.79166Z",
				stroke: "#3C3C3C",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				opacity: 0,
				d: "M0 20L20 20L20 0L0 0L0 20Z",
				fill: "#3C3C3C"
			})
		]
	})
});
export default SvgWalletUnsettled;
